import React from 'react';
import { Box, Typography } from '@mui/material';
import DateRangePicker from '../../../../components/filters/DateRangePicker';
import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './IncomingFilesFilters.styles';

const STATUS_OPTIONS = ['Fail', 'Pass', 'All'];
const FAIL_SUB_OPTIONS = ['Fail - Blocked', 'Fail - Config', 'Fail - Data', 'Fail - Late'];

export default function IncomingFilesFilters({
  filters,
  setFilters,
  dateRange,
  setDateRange,
  statusView,
  setStatusView,
  subStatusView,
  setSubStatusView,
  fileNameOptions = [],
  dataProviderOptions = [],
}) {
  const fileNames     = filters.fileName     || [];
  const dataProviders = filters.dataProvider || [];
  const showSubStatus = (statusView || []).includes('Fail');

  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => setFilters((prev) => ({ ...prev, [type]: [] }));

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Filters:</Typography>

        <ChipFilter
          label="File"
          type="fileName"
          values={fileNameOptions}
          selectedValues={fileNames}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Data Provider"
          type="dataProvider"
          values={dataProviderOptions}
          selectedValues={dataProviders}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Status"
          type="statusView"
          values={STATUS_OPTIONS}
          selectedValues={statusView || []}
          closeOnSelectProp={true}
          onToggle={(_type, val) => {
            setStatusView([val]);
            // Clear sub-status whenever top-level status changes
            setSubStatusView([]);
          }}
          onClear={() => { setStatusView(['Fail']); setSubStatusView([]); }}
        />

        {showSubStatus && (
          <ChipFilter
            label="Fail Type"
            type="subStatusView"
            values={FAIL_SUB_OPTIONS}
            selectedValues={subStatusView || []}
            closeOnSelectProp={false}
            onToggle={(_type, val) => {
              setSubStatusView((prev) => {
                const current = prev || [];
                return current.includes(val)
                  ? current.filter((v) => v !== val)
                  : [...current, val];
              });
            }}
            onClear={() => setSubStatusView([])}
          />
        )}

        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>
    </Box>
  );
}
